import { CONSTS } from '../../config/objectConst'

const isEnabled = import.meta.env.PUBLIC_SENTRY === 'true'

let sentry: null | typeof import('@sentry/react') = null

async function addUserToSentry(userId: string) {
	if (isEnabled) {
		sentry ??= await import('@sentry/react')

		sentry.setContext('app', {
			userId,
			version: CONSTS.APP_VERSION
		})
	}
}

async function initSentry() {
	if (!isEnabled) {
		return
	}

	sentry ??= await import('@sentry/react')

	sentry.init({
		allowUrls: [
			'dev.app.snaily.io',
			'app.snaily.io',
			'sandbox-app.snaily.io',
			'chrome-extension://febgaeoegckcdcdhammknmiobpjkpgbe',
			'chrome-extension://gjncjmifcnnbaggdakbkgdmfkmknijhb'
		],
		dsn: 'https://c563bd35cb0f4697bda0dfe29df80483@o1303236.ingest.sentry.io/6541994',
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.5
	})
	sentry.setTag('app_version', CONSTS.APP_VERSION)
}

async function reportToSentry(error: unknown) {
	if (isEnabled) {
		sentry ??= await import('@sentry/react')
		sentry.captureException(error)
	}
}

export { addUserToSentry, initSentry, reportToSentry }
